module.exports = __webpack_public_path__ + "static/media/massformer.dbce6bd6.md";